import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
	selector: 'xp-loading',
	standalone: true,
	imports: [MatProgressSpinnerModule],
	templateUrl: './xp-loading.component.html',
	styleUrls: ['./xp-loading.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpLoadingComponent {
	diameter = input(32);
	overlay = input(false);

	@HostBinding('class.xp-loading--overlay')
	get isOverlay(): boolean {
		return this.overlay();
	}
}
